// Wishlist drawer (Swym): use the Figma wording for the guest "log in" footer. Swym re-renders the drawer, so keep
// re-applying it. English only - other languages keep the text set in the Swym app.
(() => {
  if (!document.documentElement.lang.startsWith('en')) return;

  const COPY = {
    '.swym-storefront-layout-login-heading': 'Don’t lose your Lists!',
    '.swym-storefront-layout-login-description': 'Login to save your favorites and access them whenever, wherever!',
  };

  const apply = () => {
    Object.entries(COPY).forEach(([selector, text]) => {
      document.querySelectorAll(`swym-storefront-layout-as-drawer ${selector}`).forEach((el) => {
        if (el.textContent.trim() !== text) el.textContent = text;
      });
    });
  };

  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  apply();
})();
